var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmotionsSad = function SvgEmotionsSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-sad_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 7.5A1.667 1.667 0 1 1 5 7.5a1.667 1.667 0 0 1 3.333 0ZM15 7.5a1.667 1.667 0 1 1-3.333 0A1.667 1.667 0 0 1 15 7.5Zm-8.614 6.26a.75.75 0 1 0 1.3.747 2.666 2.666 0 0 1 4.626-.002.75.75 0 1 0 1.301-.747 4.167 4.167 0 0 0-7.227.003Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-sad_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.708 7.292) scale(15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#65B3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256BF2"
  })))));
};

export default SvgEmotionsSad;